export const SOLV_CLIENT_PATHS = {
  SOLV_KEYPAIR_DOWNLOAD_PATH: '/solvKeys/download',
  SOLV_KEYPAIR_UPLOAD_PATH: '/solvKeys/upload',
  SOLV_KEYPAIR_UPLOAD_PATH_LINUX: '/home/solv',
  SOLV_KEYPAIR_TRASH_PATH: '/solvKeys/trash',
  SSH_PUBKEY_PATH: '/.ssh/id_rsa.pub',
}
